'use client';
import { Simple as Tooltip } from '@/ui/Tooltip';
import { QuestionMarkCircledIcon } from '@radix-ui/react-icons';

import * as Styled from './styled';
import Tag from '@/ui/Tag';
import { IQueryQuotaUsage } from '@/lib/dataframeQueryApi';

const OverLimitTooltipContent = ({ user_limit }: { user_limit: number }) => (
  <>
    Your current plan includes up to {user_limit} natural language queries per day.
    <br /> If you need more, you can upgrade.
  </>
);

const QueryQuotaUsage: React.FC<{ queryQuotaUsage?: IQueryQuotaUsage }> = ({ queryQuotaUsage }) => {
  if (!queryQuotaUsage) {
    return null;
  }

  const { daily_total, user_limit, has_hit_limit } = queryQuotaUsage;

  return (
    <Styled.QueryQuotaUsage>
      <div>
        {daily_total}/{user_limit} daily NLP queries used
      </div>
      {has_hit_limit && (
        <Tag variant="error" pill>
          Daily query limit reached
        </Tag>
      )}

      <Tooltip content={<OverLimitTooltipContent user_limit={user_limit} />}>
        <QuestionMarkCircledIcon />
      </Tooltip>
    </Styled.QueryQuotaUsage>
  );
};

export default QueryQuotaUsage;
